<div *ngIf="show" class="alert alert-primary d-flex align-items-center">
  <i *ngIf="icon" [ngClass]="'fas fa-' + icon"></i>
  <div><ng-content></ng-content></div>
</div>
